module.exports = __webpack_public_path__ + "media/images/vp/icon.burgerdots.white-caa525f0508da7a08ef056b885e566eb.svg";